export enum STATUS {
    NOVO = 'N',
    APROVADO = 'A',
    REPROVADO = 'R',
    ATUALIZADO = 'U',
}

export enum CONTROLTYPE {
    DISEASES = 'D',
    PESTS = 'P'
}

export type GroupType = {
    url: string,
    id: number
    name: string,
}

export type UserType = {
    id: number
    url: string
    username: string
    email: string
    groups: Array<GroupType>
    permissions: Array<string>
    pessoa: PessoaType
    planos: Array<PlanoType>
    propriedades: Array<ImovelType>
}

export type History = {
    id: number,
    action: number,
    user: number,
    date_time: string
}

export type PessoaType = {
    id: string;
    nome_razao: string;
    cpf_cnpj: string;
    rg_insc: string;
    paper: any;
    cep: string;
    endereco: string;
    numero: string;
    bairro: string;
    cidade: string;
    uf: string;
    conj_resp: number | null;
    celular: string;
    email: string;
    farms: Array<ImovelType>;
    doc_cpf_cartao_cnpj: any;
    doc_rg: any;
    doc_res: any;
    doc_passaporte: any;
    user: any;
    avaliador: any;
    avaliacao: any;
    pessoa_atualizada: any;
    status: STATUS
    registro_rt?: string | null;
    conselho_rt?: string | null;
    conselho_uf?: string | null;
    doc_rt?: string | null;
    avaliador_rt?: any | null;
    avaliacao_rt?: Date | null;
    status_rt?: STATUS;
    receber_notificacoes?: boolean;
    // history: any;
}

export function newPessoa(): PessoaType {
    return {
        id: '',
        nome_razao: '',
        cpf_cnpj: '',
        rg_insc: '',
        paper: null,
        cep: '',
        endereco: '',
        numero: '',
        bairro: '',
        cidade: '',
        uf: '',
        conj_resp: null,
        celular: '',
        email: '',
        farms: [],
        doc_cpf_cartao_cnpj: null,
        doc_rg: null,
        doc_res: null,
        doc_passaporte: null,
        user: null,
        avaliador: null,
        avaliacao: null,
        pessoa_atualizada: null,
        status: STATUS.NOVO,
        receber_notificacoes: true,
        // history: null
    };
}

export type ImovelType = {
    id: number;
    history: any;
    nome: string;
    proprietario: any;
    localidade: string;
    acesso: string;
    municipio: any;
    municipio_nome?: string
    poligono: any;
    doc_matricula: any;
    lotes: Array<LoteType>
    planos?: Array<PlanoType>
    status: STATUS;
}

export function newImovel(): ImovelType {
    return {
        id: 0,
        history: null,
        nome: '',
        proprietario: null,
        localidade: '',
        acesso: '',
        municipio: null,
        municipio_nome: '',
        poligono: null,
        doc_matricula: null,
        lotes: [],
        status: STATUS.NOVO
    };
}

export type LoteType = {
    id: number | null
    propriedade: any | null
    arrendatario: any | null
    arrendamento_inicio: Date | null
    arrendamento_final: Date | null
    poligono: any | null
    contrato: string | null
    arrendatario_nome: string | null
    propriedade_nome: string | null
    status: STATUS
}

export function newLote(): LoteType {
    return {
        id: null,
        propriedade: null,
        arrendatario: null,
        arrendamento_inicio: null,
        arrendamento_final: null,
        poligono: null,
        contrato: null,
        arrendatario_nome: null,
        propriedade_nome: null,
        status: STATUS.NOVO
    };
}
export type SafraType = {
    url: string
    id: number
    periodo: string
}
export type PlanoType = {
    url: string;
    id: number | null;
    safra: any;
    propriedade: any;
    responsavel_tecnico: any;
    observacoes: any;

    plantios?: Array<PlantioType> | null

    drt: string,
    doc_drt: any,
    aprovacao_rt: any,
    aprovacao_rt_status: STATUS,
    plano_avaliacao_associacao: any,
    plano_avaliador_associacao: any,
    plano_observacoes_associacao: any,
    plano_status: STATUS,
    termo: any,
    termo_assinado_produtor: any,
    termo_avaliacao_defesa: any,
    termo_avaliador_defesa: any,
    termo_observacoes_defesa: any,
    termo_assinado_defesa: any,
    termo_status: STATUS,
    requerimento: any,
    requerimento_assinado_produtor: any,
    requerimento_avaliacao_defesa: any,
    requerimento_avaliador_defesa: any,
    requerimento_observacoes_defesa: any,
    requerimento_assinado_defesa: any,
    requerimento_status: STATUS,
    controles_rt: any,
    controles_observacoes_rt: any,
    controles_doc: any,
    controles_avaliacao_associacao: any,
    controles_avaliador_associacao: any,
    controles_observacoes_associacao: any,
    controles_status_associacao: STATUS,
    controles_assinado_produtor: any,
    controles_avaliacao_defesa: any,
    controles_avaliador_defesa: any,
    controles_observacoes_defesa: any,
    controles_assinado_defesa: any,
    controles_status: STATUS,
    sei: any
}
export function newPlano(): PlanoType {
    return {
        url: '',
        id: null,
        safra: null,
        propriedade: null,
        responsavel_tecnico: null,
        observacoes: null,

        plantios: null,

        drt: '',
        doc_drt: null,
        aprovacao_rt: null,
        aprovacao_rt_status: STATUS.NOVO,
        plano_avaliacao_associacao: null,
        plano_avaliador_associacao: null,
        plano_observacoes_associacao: null,
        plano_status: STATUS.NOVO,
        termo: null,
        termo_assinado_produtor: null,
        termo_avaliacao_defesa: null,
        termo_avaliador_defesa: null,
        termo_observacoes_defesa: null,
        termo_assinado_defesa: null,
        termo_status: STATUS.NOVO,
        requerimento: null,
        requerimento_assinado_produtor: null,
        requerimento_avaliacao_defesa: null,
        requerimento_avaliador_defesa: null,
        requerimento_observacoes_defesa: null,
        requerimento_assinado_defesa: null,
        requerimento_status: STATUS.NOVO,
        controles_rt: null,
        controles_observacoes_rt: null,
        controles_doc: null,
        controles_avaliacao_associacao: null,
        controles_avaliador_associacao: null,
        controles_observacoes_associacao: null,
        controles_status_associacao: STATUS.NOVO,
        controles_assinado_produtor: null,
        controles_avaliacao_defesa: null,
        controles_avaliador_defesa: null,
        controles_observacoes_defesa: null,
        controles_assinado_defesa: null,
        controles_status: STATUS.NOVO,
        sei: null
    };
}

export type PlantioType = {
    id: number | null
    data: Date | null
    cultura: any | null
    variedade: any | null
    produtividade: number | null
    irrigacao_poco: boolean
    irrigacao_fluvial: boolean
    plano: PlanoType | null
    lotes?: Array<LoteType> | null
}

export function newPlantio(): PlantioType {
    return {
        id: null,
        data: null,
        cultura: null,
        variedade: null,
        produtividade: null,
        irrigacao_poco: false,
        irrigacao_fluvial: false,
        plano: null
    };
}

export type PlantioLoteType = {
    id: number | null
    plantio: PlantioType | null
    lote: LoteType | null
}

export function newPlantioLote(): PlantioLoteType {
    return {
        id: null,
        plantio: null,
        lote: null
    };
}

export type ControleType = {
    id: number | null
    plantio: any | null
    tipo: CONTROLTYPE | null
    nome: string | null
    produto: any | null
    fabricante: any | null
    aplicacao: string | null
    dose: string | null
    epoca: string | null
}

export function newControle(): ControleType {
    return {
        id: null,
        plantio: null,
        tipo: null,
        nome: null,
        produto: null,
        fabricante: null,
        aplicacao: null,
        dose: null,
        epoca: null,
    };
}

export type ArrendamentoType = {
    id: number
    url?: string
    arrendatario?: number
    arrendamento_inicio?: string
    arrendamento_final?: string
    contrato?: string
    lotes?: Array<any>
    status?: string
    avaliacao?: string
}

export function newArrendamento(): ArrendamentoType {
    return {
        id: 0,
        url: '',
        arrendatario: 0,
        arrendamento_inicio: '',
        arrendamento_final: '',
        contrato: '',
        lotes: [],
        status: STATUS.NOVO
    };
}

export type PermissionType = {
    url: string
    string_perm: string
    id: number
    name: string
    content_type: number
    codename: string
}

export interface keyPairMap {
    [id: number]: any
}
export interface mapStringToAny {
    [key: string]: any
}

export interface StationData {
    DC_NOME: string;      // Nome da estação
    PRE_INS: string;      // Pressão
    TEM_INS: string;      // Temperatura Instantânea (°C)
    UMD_INS: string;      // Umidade
    VEN_DIR: string;      // Direção do Vento
    VEN_VEL: string;      // Velocidade do Vento
    VL_LATITUDE: string;  // Latitude
    VL_LONGITUDE: string; // Longitude
    CD_ESTACAO: string;   // Código da estação
    HR_MEDICAO: string;   // Hora da medição
    DT_MEDICAO: string;   // Data da medição
}
